"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP712Proxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IEAS",
                name: "eas",
                type: "address",
            },
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AccessDenied",
        type: "error",
    },
    {
        inputs: [],
        name: "DeadlineExpired",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidEAS",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "NotFound",
        type: "error",
    },
    {
        inputs: [],
        name: "UsedSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "recipient",
                                type: "address",
                            },
                            {
                                internalType: "uint64",
                                name: "expirationTime",
                                type: "uint64",
                            },
                            {
                                internalType: "bool",
                                name: "revocable",
                                type: "bool",
                            },
                            {
                                internalType: "bytes32",
                                name: "refUID",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct AttestationRequestData",
                        name: "data",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct EIP712Signature",
                        name: "signature",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "deadline",
                        type: "uint64",
                    },
                ],
                internalType: "struct DelegatedProxyAttestationRequest",
                name: "delegatedRequest",
                type: "tuple",
            },
        ],
        name: "attestByDelegation",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAttestTypeHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "uid",
                type: "bytes32",
            },
        ],
        name: "getAttester",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDomainSeparator",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getEAS",
        outputs: [
            {
                internalType: "contract IEAS",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getName",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRevokeTypeHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        components: [
                            {
                                internalType: "address",
                                name: "recipient",
                                type: "address",
                            },
                            {
                                internalType: "uint64",
                                name: "expirationTime",
                                type: "uint64",
                            },
                            {
                                internalType: "bool",
                                name: "revocable",
                                type: "bool",
                            },
                            {
                                internalType: "bytes32",
                                name: "refUID",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes",
                                name: "data",
                                type: "bytes",
                            },
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct AttestationRequestData[]",
                        name: "data",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct EIP712Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "address",
                        name: "attester",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "deadline",
                        type: "uint64",
                    },
                ],
                internalType: "struct MultiDelegatedProxyAttestationRequest[]",
                name: "multiDelegatedRequests",
                type: "tuple[]",
            },
        ],
        name: "multiAttestByDelegation",
        outputs: [
            {
                internalType: "bytes32[]",
                name: "",
                type: "bytes32[]",
            },
        ],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "uid",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct RevocationRequestData[]",
                        name: "data",
                        type: "tuple[]",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct EIP712Signature[]",
                        name: "signatures",
                        type: "tuple[]",
                    },
                    {
                        internalType: "address",
                        name: "revoker",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "deadline",
                        type: "uint64",
                    },
                ],
                internalType: "struct MultiDelegatedProxyRevocationRequest[]",
                name: "multiDelegatedRequests",
                type: "tuple[]",
            },
        ],
        name: "multiRevokeByDelegation",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "schema",
                        type: "bytes32",
                    },
                    {
                        components: [
                            {
                                internalType: "bytes32",
                                name: "uid",
                                type: "bytes32",
                            },
                            {
                                internalType: "uint256",
                                name: "value",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct RevocationRequestData",
                        name: "data",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "uint8",
                                name: "v",
                                type: "uint8",
                            },
                            {
                                internalType: "bytes32",
                                name: "r",
                                type: "bytes32",
                            },
                            {
                                internalType: "bytes32",
                                name: "s",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct EIP712Signature",
                        name: "signature",
                        type: "tuple",
                    },
                    {
                        internalType: "address",
                        name: "revoker",
                        type: "address",
                    },
                    {
                        internalType: "uint64",
                        name: "deadline",
                        type: "uint64",
                    },
                ],
                internalType: "struct DelegatedProxyRevocationRequest",
                name: "delegatedRequest",
                type: "tuple",
            },
        ],
        name: "revokeByDelegation",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class EIP712Proxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(eas, name, overrides) {
        return super.deploy(eas, name, overrides || {});
    }
    getDeployTransaction(eas, name, overrides) {
        return super.getDeployTransaction(eas, name, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EIP712Proxy__factory = EIP712Proxy__factory;
//# sourceMappingURL=EIP712Proxy__factory.js.map